import clientSettings from "../constants";

const state = {
  client: "fwwf",
};

// initialize the state with the client settings
Object.assign(state, { ...clientSettings[state.client.toLowerCase()] });

const mutations = {
  showAlert(state, alert) {
    state.alert = alert;
  },
  alertConfirm(state) {
    state.alertStatus = !state.alertStatus;
  },
  hydrateClientSettings(state) {
    const settings = clientSettings[state.client.toLowerCase()];

    Object.assign(state, { ...settings });
  },
  updateSubAppName(state, name) {
    state.subAppName = name;
  },
};
const getters = {
  isDark: (state) => {
    let color = state.appColor;
    let r, g, b;
    if (color.match(/^rgb/)) {
      // If HEX --> store the red, green, blue values in separate variables
      color = color.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
      );

      r = color[1];
      g = color[2];
      b = color[3];
    } else {
      color = +(
        "0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&")
      );

      r = color >> 16;
      g = (color >> 8) & 255;
      b = color & 255;
    }

    const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    // Using the HSP value, determine whether the color is light or dark
    if (hsp > 127.5) {
      return false;
    } else {
      return true;
    }
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
